export const MASCARA_NUMEROS = (value: string) => {
    return value
    .replace(/\D/g, "")
  }